import { render, staticRenderFns } from "./CollegeArea.vue?vue&type=template&id=ef14e5fc&"
import script from "./CollegeArea.vue?vue&type=script&lang=js&"
export * from "./CollegeArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports